import { Flex, useSafeArea } from '@banhala/ui-kit';
import Animated, {
  interpolate,
  useAnimatedStyle,
  type SharedValue,
} from 'react-native-reanimated';
import { ScrollToTopButton } from 'shared/src/component';

interface LikeScrollToTopButtonProps {
  scrollY: SharedValue<number>;
  onPress: () => void;
}

/**
 * AtomicRenderer 의 ScrollToTopButton 과 동일 동작
 */
export const LikeScrollToTopButton = ({
  scrollY,
  onPress,
}: LikeScrollToTopButtonProps) => {
  const { bottom } = useSafeArea();

  const style = useAnimatedStyle(() => ({
    transform: [
      {
        translateY: interpolate(
          scrollY.value,
          [0, 300, 310],
          [100, 100, 0],
          'clamp',
        ),
      },
    ],
  }));

  return (
    <Flex position={'absolute'} right={16} bottom={16 + bottom} zIndex={1}>
      <Animated.View style={style}>
        <ScrollToTopButton testID={'like-scroll-to-top'} onPress={onPress} />
      </Animated.View>
    </Flex>
  );
};
